import { render, staticRenderFns } from "./PointBlockingModal.vue?vue&type=template&id=5f0fb812&scoped=true"
import script from "./PointBlockingModal.vue?vue&type=script&lang=js"
export * from "./PointBlockingModal.vue?vue&type=script&lang=js"
import style0 from "./PointBlockingModal.vue?vue&type=style&index=0&id=5f0fb812&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f0fb812",
  null
  
)

export default component.exports